export var FIELD_ERROR = 'field-error';
export var FIELD_LABEL = 'field-label';
export var FIELD_SUPPORTIVE = 'field-supportive';
export var TOOLTIP_CLOSE = 'tooltip-close';
export var TOOLTIP_CONTENT = 'tooltip-content';
export var TOOLTIP_TARGET = 'tooltip-target';
export var TOOLTIP_TITLE = 'tooltip-title';